
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hFFoW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $542c6f7e0c33d24b$export$2e2bcd8739ae039);

var $5DfTA = parcelRequire("5DfTA");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2nybh = parcelRequire("2nybh");
function $542c6f7e0c33d24b$export$2e2bcd8739ae039({ queries: { queryRef: queryRef } }) {
    const data = (0, $j4oe4.usePreloadedQuery)((0, $5DfTA.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2nybh.DashboardsContentRefactored), {
        queryRef: data
    });
}

});
parcelRegister("5DfTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $26ee87a857f09e34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0405d673000c989ac1cce8c36c943990>>
 * @relayHash 239f776c48d72505a2faa3da5e6bf83b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6e166150dee7281832d718ecf24857cad97c709fd7df403621399361bd8013c

var $37Ewn = parcelRequire("37Ewn");
const $26ee87a857f09e34$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "dashboardId"
    }, v6 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v3 /*: any*/ 
        ]
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v8 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "DashboardsContentViewRefactoredQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "DashboardsContentRefactored"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "DashboardsContentViewRefactoredQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "dashboardFavourites",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "DASHBOARD"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "dashboardRecents",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "DASHBOARD"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "alias": "dashboardOrder",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "ownerAri",
                            "variableName": "ownerAri"
                        }
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItemConnection",
                            "kind": "LinkedField",
                            "name": "sidebar",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SettingsMenuItem",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "visible"
                                        }
                                    ]
                                }
                            ]
                        },
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "e6e166150dee7281832d718ecf24857cad97c709fd7df403621399361bd8013c",
            "metadata": {},
            "name": "DashboardsContentViewRefactoredQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$26ee87a857f09e34$var$node.hash = "64d78fdb9ec9bf0904a5ca6d33e37bf5";
(0, $37Ewn.PreloadableQueryRegistry).set($26ee87a857f09e34$var$node.params.id, $26ee87a857f09e34$var$node);
var $26ee87a857f09e34$export$2e2bcd8739ae039 = $26ee87a857f09e34$var$node;

});

parcelRegister("2nybh", function(module, exports) {
$parcel$export(module.exports, "DashboardsContentRefactored", () => $d9b6e2ac9a76d45a$export$c8bedd0ce6277a65);

var $17ROM = parcelRequire("17ROM");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $5SdQs = parcelRequire("5SdQs");

var $lRq8t = parcelRequire("lRq8t");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $hc6Nm = parcelRequire("hc6Nm");

var $i0tMD = parcelRequire("i0tMD");

var $h3HFC = parcelRequire("h3HFC");

var $3uQAw = parcelRequire("3uQAw");

var $cHtIB = parcelRequire("cHtIB");

var $jyIAe = parcelRequire("jyIAe");

var $ht7jn = parcelRequire("ht7jn");

var $2QH3X = parcelRequire("2QH3X");

var $h4nrK = parcelRequire("h4nrK");

var $fVLoz = parcelRequire("fVLoz");

var $4RWsk = parcelRequire("4RWsk");

var $gKigs = parcelRequire("gKigs");

var $9h67t = parcelRequire("9h67t");

var $9twek = parcelRequire("9twek");

var $6L63Q = parcelRequire("6L63Q");
const $d9b6e2ac9a76d45a$var$MAX_RECENT_DASHBOARD = 5;
const $d9b6e2ac9a76d45a$var$MAX_FAVORITE_DASHBOARDS = 15;
const $d9b6e2ac9a76d45a$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
function $d9b6e2ac9a76d45a$export$c8bedd0ce6277a65({ queryRef: queryRef }) {
    const cloudId = (0, $cHtIB.useCloudId)();
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const { getStableItems: getStableItems } = (0, $3uQAw.useStableItems)();
    // https://jplat.jira.atlassian.cloud/browse/BLU-2719
    // We intentionally request 15 starred and 20 recent dashboards.
    // Then, if all 10 starred dashboards were recently visited, we still show 5 recent dashboards as well.
    const [{ jira: { dashboardFavourites: dashboardFavourites, dashboardRecents: dashboardRecents }, dashboardOrder: dashboardOrder }, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $17ROM.default), queryRef);
    (0, $hc6Nm.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $9twek.default,
        refetch: refetch,
        menuId: (0, $h4Bzb.MENU_ID_DASHBOARDS)
    });
    const refetchOnChange = (0, $eJOHy.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $h3HFC.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraDashboard',
        favouriteConnectionId: dashboardFavourites.__id,
        recentConnectionId: dashboardRecents.__id,
        refetch: refetchOnChange
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const starred = formatMessage((0, $6L63Q.default).starred);
    const recent = formatMessage((0, $6L63Q.default).recent);
    const customerService = formatMessage((0, $6L63Q.default).customerService);
    const showNestedCustomerServiceAnalytics = (0, $ht7jn.useShowCustomerServiceAnalytics)();
    // Use dashboard-specific message when AVP flag is on (which is the only time this item is shown in dashboard context)
    const { formattedMessage: customerServiceOverviewLabel, icon: dashboardsIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $6L63Q.default).customerServiceOverview, (0, (/*@__PURE__*/$parcel$interopDefault($5SdQs))));
    const { entityAri: entityAri, ownerAri: ownerAri, group: group } = (0, $gKigs.useDashboardReorderingIds)();
    const dashboardNodes = (0, $eJOHy.useMemo)(()=>dashboardFavourites.edges?.map((edge)=>edge?.node).filter((node)=>node != null) ?? [], [
        dashboardFavourites.edges
    ]);
    const favorites = (0, $fVLoz.useReorderableStarredItems)({
        favourites: dashboardNodes,
        lastOrder: dashboardOrder?.sidebar?.nodes,
        getId: (item)=>item.id || '',
        getLabel: (item)=>item.title?.toString() || '',
        getHasNextPage: ()=>Boolean(dashboardFavourites?.pageInfo?.hasNextPage),
        renderMenuItem: (edge, currentItems, currentOrder, item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9h67t.DashboardMenuItemRefactored), {
                key: edge.dashboardId,
                queryRef: edge,
                currentItems: currentItems,
                currentOrder: currentOrder,
                item: item
            }),
        maxItems: $d9b6e2ac9a76d45a$var$MAX_FAVORITE_DASHBOARDS
    });
    const recentItems = (0, $eJOHy.useMemo)(()=>{
        const nodes = dashboardRecents.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, $d9b6e2ac9a76d45a$var$MAX_RECENT_DASHBOARD) || [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'id'
        });
        const list = stableOrderedNodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9h67t.DashboardMenuItemRefactored), {
                key: node.dashboardId,
                queryRef: node
            }));
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        dashboardRecents.edges,
        favorites.idSet,
        getStableItems
    ]);
    if (!favorites.hasItems && !recentItems.hasItems && !showNestedCustomerServiceAnalytics) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4RWsk.DashboardsEmptyContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h4nrK.NestedItemDropTarget), {
        currentItems: favorites.currentItems,
        currentOrder: favorites.currentOrder,
        entityAri: entityAri,
        group: group,
        ownerAri: ownerAri
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, favorites.list))), favorites.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: $d9b6e2ac9a76d45a$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $h4Bzb.MENU_ID_DASHBOARDS_VIEW_ALL_STARRED)
    }, formatMessage((0, $6L63Q.default).viewAllStarred))), recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, recentItems.list))), showNestedCustomerServiceAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, customerService), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: (0, $jyIAe.CUSTOMER_SERVICE_ANALYTICS_HREF),
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
        elemBefore: dashboardsIcon
    }, customerServiceOverviewLabel)))));
}

});
parcelRegister("17ROM", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cc5a2c508d0ae1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<366f331668321326290e0f8c0c3ae6d9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $46smr = parcelRequire("46smr");
const $9cc5a2c508d0ae1b$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "dashboardId"
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "DashboardMenuItemRefactored"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            },
            {
                "kind": "RootArgument",
                "name": "entityAri"
            },
            {
                "kind": "RootArgument",
                "name": "ownerAri"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $46smr.default)
            }
        },
        "name": "DashboardsContentRefactored",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "dashboardFavourites",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "DASHBOARD"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.dashboardFavourites.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "kind": "ScalarField",
                                                                        "name": "title"
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.dashboardFavourites.edges.node.title"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v2 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.dashboardFavourites.edges.node.dashboardId"
                                                                },
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraDashboard"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.dashboardFavourites.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.dashboardFavourites"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "dashboardRecents",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURL"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "DASHBOARD"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.dashboardRecents.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraDashboard"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.dashboardRecents.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.dashboardRecents"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            },
            {
                "alias": "dashboardOrder",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "entityAri",
                        "variableName": "entityAri"
                    },
                    {
                        "kind": "Variable",
                        "name": "ownerAri",
                        "variableName": "ownerAri"
                    }
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SettingsMenuItemConnection",
                        "kind": "LinkedField",
                        "name": "sidebar",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "SettingsMenuItem",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "menuId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "visible"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$9cc5a2c508d0ae1b$var$node.hash = "ae6830494fafa0893401f12ba570e85a";
var $9cc5a2c508d0ae1b$export$2e2bcd8739ae039 = $9cc5a2c508d0ae1b$var$node;

});
parcelRegister("46smr", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2e2295349552def$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5318a542141934a208616940e4b7bc0>>
 * @relayHash 8277b0840211be10cc85a358d59f63c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92edf9707a5a2cf80fc4a6f194605b89124aa3bc573d0dfc990395abbc78e7eb
const $c2e2295349552def$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "dashboardId"
    }, v7 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v4 /*: any*/ 
        ]
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4DashboardsContentRefactoredQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "DashboardsContentRefactored"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4DashboardsContentRefactoredQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "dashboardFavourites",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "DASHBOARD"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "dashboardRecents",
                            "args": [
                                v2 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "DASHBOARD"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "alias": "dashboardOrder",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "ownerAri",
                            "variableName": "ownerAri"
                        }
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItemConnection",
                            "kind": "LinkedField",
                            "name": "sidebar",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SettingsMenuItem",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "visible"
                                        }
                                    ]
                                }
                            ]
                        },
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "92edf9707a5a2cf80fc4a6f194605b89124aa3bc573d0dfc990395abbc78e7eb",
            "metadata": {},
            "name": "Nav4DashboardsContentRefactoredQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c2e2295349552def$var$node.hash = "ae6830494fafa0893401f12ba570e85a";
var $c2e2295349552def$export$2e2bcd8739ae039 = $c2e2295349552def$var$node;

});


parcelRegister("jyIAe", function(module, exports) {
$parcel$export(module.exports, "CUSTOMER_SERVICE_ANALYTICS_HREF", () => $ceb5d334a4e24ed4$export$df8bbcec1e54e3c3);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $i0tMD = parcelRequire("i0tMD");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");
const $ceb5d334a4e24ed4$export$df8bbcec1e54e3c3 = '/jira/helpcenter/analytics';
const $ceb5d334a4e24ed4$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
        hasSeparator: false
    }));
const $ceb5d334a4e24ed4$export$d4508bff4cbbd271 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customer-service-analytics.ui.sidenav-customer-service",
        href: $ceb5d334a4e24ed4$export$df8bbcec1e54e3c3,
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
            MenuItems: $ceb5d334a4e24ed4$var$MenuItems
        })
    }, formattedMessage);
};

});

parcelRegister("ht7jn", function(module, exports) {
$parcel$export(module.exports, "useShowCustomerServiceAnalytics", () => $594909db36a8e283$export$4aaa66e80d627346);

var $cblKs = parcelRequire("cblKs");

var $kAwwe = parcelRequire("kAwwe");

var $1BZ8a = parcelRequire("1BZ8a");
const $594909db36a8e283$export$4aaa66e80d627346 = ()=>{
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const { customerService: customerService } = (0, $1BZ8a.useAppEditions)();
    if (customerService === (0, $cblKs.UNLICENSED)) return false;
    return isAdmin;
};

});

parcelRegister("4RWsk", function(module, exports) {
$parcel$export(module.exports, "DashboardsEmptyContent", () => $46bad5fbeee0f043$export$54678b9782e1c19b);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $eLY13 = parcelRequire("eLY13");

var $a9Cnb = parcelRequire("a9Cnb");
function $46bad5fbeee0f043$export$54678b9782e1c19b() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eLY13.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $a9Cnb.default).emptyDashboardsMessage)));
}

});
parcelRegister("a9Cnb", function(module, exports) {
$parcel$export(module.exports, "default", () => $19f3ace543b45940$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $19f3ace543b45940$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyDashboardsMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.empty-content.empty-dashboards-message",
        "defaultMessage": "Once you visit or create dashboards, they\u2019ll show up here."
    }
});

});


parcelRegister("gKigs", function(module, exports) {
$parcel$export(module.exports, "useDashboardReorderingIds", () => $52ddb46b4d7a6d4c$export$ac1a8660c818916b);

var $7Cu03 = parcelRequire("7Cu03");

var $3MbOI = parcelRequire("3MbOI");

var $cHtIB = parcelRequire("cHtIB");

var $fKh2A = parcelRequire("fKh2A");

var $f2sjT = parcelRequire("f2sjT");
const $52ddb46b4d7a6d4c$export$ac1a8660c818916b = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const activationId = (0, $f2sjT.useActivationId)();
    const { data: { user: { accountId: accountId } } } = (0, $3MbOI.useCurrentUser)();
    const entityAri = (0, $fKh2A.JiraNavigationSettingsAri).create({
        siteId: cloudId,
        activationId: activationId,
        navigationSettingScope: 'dashboards'
    }).toString();
    const ownerAri = (0, $7Cu03.IdentityUserAri).create({
        userId: accountId || 'UNKNOWN'
    }).toString();
    return {
        entityAri: entityAri,
        ownerAri: ownerAri,
        group: 'SIDE_NAVIGATION_STARRED_DASHBOARDS'
    };
};

});

parcelRegister("9h67t", function(module, exports) {
$parcel$export(module.exports, "DashboardMenuItemRefactored", () => $df00cf13e06b2d5a$export$fefe1f1e4f2bddfe);

var $276Mv = parcelRequire("276Mv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5SdQs = parcelRequire("5SdQs");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $9s5NF = parcelRequire("9s5NF");

var $kJJos = parcelRequire("kJJos");

var $gKigs = parcelRequire("gKigs");

var $lX4dA = parcelRequire("lX4dA");
function $df00cf13e06b2d5a$export$fefe1f1e4f2bddfe({ queryRef: queryRef, currentItems: currentItems, currentOrder: currentOrder, item: item }) {
    const data = (0, $j4oe4.useFragment)((0, $276Mv.default), queryRef);
    const { fireUIAnalyticForDashboardItems: fireUIAnalyticForDashboardItems } = (0, $eJOHy.useContext)((0, $kJJos.AnalyticContext));
    if (!data) return null;
    const dashboardUrl = `/jira/dashboards/${data.dashboardId}`;
    if (data?.favouriteValue?.isFavourite) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df00cf13e06b2d5a$var$DraggableDashboardMenuItem, {
        data: data,
        dashboardUrl: dashboardUrl,
        currentItems: currentItems,
        currentOrder: currentOrder,
        item: item
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: dashboardUrl,
        menuId: (0, $h4Bzb.ENTITY_ID).DASHBOARD(String(data.dashboardId)),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lX4dA.DashboardPopupMenuRefactored), {
            dashboardData: data
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5SdQs))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>{
            fireUIAnalyticForDashboardItems({
                itemId: String(data.dashboardId),
                section: data?.favouriteValue?.isFavourite ? (0, $a9aec.SECTION_ITEM_STARRED) : (0, $a9aec.SECTION_ITEM_RECENT)
            });
        }
    }, data.title);
}
const $df00cf13e06b2d5a$var$DraggableDashboardMenuItem = ({ data: data, dashboardUrl: dashboardUrl, currentItems: currentItems, currentOrder: currentOrder, item: item })=>{
    const { fireUIAnalyticForDashboardItems: fireUIAnalyticForDashboardItems } = (0, $eJOHy.useContext)((0, $kJJos.AnalyticContext));
    const { entityAri: entityAri, ownerAri: ownerAri, group: group } = (0, $gKigs.useDashboardReorderingIds)();
    const dragAndDropState = (0, $9s5NF.useNestedItemDragAndDrop)({
        entityAri: entityAri,
        ownerAri: ownerAri,
        data: {
            id: data.id,
            label: data.title
        },
        group: group,
        item: undefined,
        isExpandable: false,
        isExpandOrFlyoutOpen: false,
        id: data.id,
        isDragAndDropEnabled: true,
        onExpandFlyoutToggle: ()=>{
        // No op for dashboard menu item
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: dashboardUrl,
        menuId: (0, $h4Bzb.ENTITY_ID).DASHBOARD(String(data.id)),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lX4dA.DashboardPopupMenuRefactored), {
            dashboardData: data,
            currentItems: currentItems,
            currentOrder: currentOrder,
            item: item
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5SdQs))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>{
            fireUIAnalyticForDashboardItems({
                itemId: String(data.dashboardId),
                section: data?.favouriteValue?.isFavourite ? (0, $a9aec.SECTION_ITEM_STARRED) : (0, $a9aec.SECTION_ITEM_RECENT)
            });
        },
        ref: dragAndDropState?.draggableRef,
        visualContentRef: dragAndDropState?.dropTargetRef,
        dropIndicator: dragAndDropState?.dropIndicator,
        isDragging: dragAndDropState?.isDragging,
        hasDragIndicator: true
    }, data.title), dragAndDropState && dragAndDropState.maybeDragPreview);
};

});
parcelRegister("276Mv", function(module, exports) {
$parcel$export(module.exports, "default", () => $05ec34a6ec6d23f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1da415fab26d6200f53d9b35a8f5b482>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $05ec34a6ec6d23f8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DashboardMenuItemRefactored",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW",
            "path": "title"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "dashboardId"
            },
            "action": "THROW",
            "path": "dashboardId"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "DashboardPopupMenuRefactored"
        }
    ],
    "type": "JiraDashboard"
};
$05ec34a6ec6d23f8$var$node.hash = "bd58c2443da542685ca185eb4152abd6";
var $05ec34a6ec6d23f8$export$2e2bcd8739ae039 = $05ec34a6ec6d23f8$var$node;

});

parcelRegister("lX4dA", function(module, exports) {
$parcel$export(module.exports, "DashboardPopupMenuRefactored", () => $becffe8b985e285b$export$74efc8db7d99692e);

var $4PRZG = parcelRequire("4PRZG");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2sLVw = parcelRequire("2sLVw");

var $85fS3 = parcelRequire("85fS3");


var $6Hwhu = parcelRequire("6Hwhu");

var $8z6Yy = parcelRequire("8z6Yy");

var $9CJDL = parcelRequire("9CJDL");


var $kJJos = parcelRequire("kJJos");

var $gKigs = parcelRequire("gKigs");
const $becffe8b985e285b$export$74efc8db7d99692e = ({ dashboardData: dashboardData, currentItems: currentItems, currentOrder: currentOrder, item: item })=>{
    const data = (0, $j4oe4.useFragment)((0, $4PRZG.default), dashboardData);
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton, fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle } = (0, $eJOHy.useContext)((0, $kJJos.AnalyticContext));
    const handleNavMenuOpen = (0, $eJOHy.useCallback)(()=>{
        fireUIAnalyticForFixButton({
            itemId: (0, $e6bca68b75395543$export$f06dfcec5ff912e)
        });
    }, [
        fireUIAnalyticForFixButton
    ]);
    const isFavourite = Boolean(data?.favouriteValue?.isFavourite);
    const handleFavouriteClick = (0, $eJOHy.useCallback)(()=>{
        fireUIAnalyticForFavouriteToggle({
            starType: isFavourite ? (0, $63bde0b156ffab77$export$5fe513938f2c4081) : (0, $63bde0b156ffab77$export$54408be40394d82a),
            parentItemId: String(data.dashboardId)
        });
    }, [
        data.dashboardId,
        fireUIAnalyticForFavouriteToggle,
        isFavourite
    ]);
    const MenuItems = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Hwhu.FavoriteToggleButton), {
            entityId: data.id,
            defaultIsStarred: isFavourite,
            entityTypeName: "JiraDashboard",
            onClick: handleFavouriteClick
        }), currentItems && currentOrder && item ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($becffe8b985e285b$var$ReorderActions, {
            currentItems: currentItems,
            currentOrder: currentOrder,
            item: item
        }) : null), [
        currentItems,
        currentOrder,
        data.id,
        handleFavouriteClick,
        isFavourite,
        item
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: MenuItems
    }));
};
const $becffe8b985e285b$var$ReorderActions = ({ currentItems: currentItems, currentOrder: currentOrder, item: item })=>{
    const { entityAri: entityAri, ownerAri: ownerAri } = (0, $gKigs.useDashboardReorderingIds)();
    const actions = (0, $9CJDL.useNavigationItemActions)({
        currentItems: currentItems,
        currentOrder: currentOrder,
        entityAri: entityAri,
        ownerAri: ownerAri,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getItemId: (i)=>i.id,
        item: item
    });
    return actions;
};

});
parcelRegister("4PRZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $2298cdd34f5bd4d2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e29b5259f9c1a18b3038869cbaceef99>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2298cdd34f5bd4d2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DashboardPopupMenuRefactored",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "dashboardId"
            },
            "action": "THROW",
            "path": "dashboardId"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        }
    ],
    "type": "JiraDashboard"
};
$2298cdd34f5bd4d2$var$node.hash = "e8e3f0c665439b68ea28735cdcb03c47";
var $2298cdd34f5bd4d2$export$2e2bcd8739ae039 = $2298cdd34f5bd4d2$var$node;

});

const $63bde0b156ffab77$export$54408be40394d82a = 'star';
const $63bde0b156ffab77$export$5fe513938f2c4081 = 'unstar';

const $e6bca68b75395543$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Dashboards';
const $e6bca68b75395543$export$d57b6b390e78d90f = 'jira-cosmos';
const $e6bca68b75395543$export$65b778215f917c60 = 'viewAllDashboards';
const $e6bca68b75395543$export$7be02fe416808d26 = 'createDashboard';
const $e6bca68b75395543$export$f06dfcec5ff912e = 'meatballDropdown';



parcelRegister("9twek", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae7cd955d2988a82$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be6f5993018a343b4acafe0061e2e04e>>
 * @relayHash abf151795028f3770a9300523a04af00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae80ab59ee2189cebc2881d3c421bf61d0f5f6840817cb3dddfaff62c6677a31
const $ae7cd955d2988a82$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraDashboard"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ 
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                }
            ]
        }
    ], v5 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4DashboardsContentQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "DashboardsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4DashboardsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "dashboardFavourites",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "DASHBOARD"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v4 /*: any*/ 
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "dashboardRecents",
                            "args": [
                                v2 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "DASHBOARD"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v4 /*: any*/ 
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ae80ab59ee2189cebc2881d3c421bf61d0f5f6840817cb3dddfaff62c6677a31",
            "metadata": {},
            "name": "Nav4DashboardsContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ae7cd955d2988a82$var$node.hash = "2efc6b73165a1bbb92f1953043700da4";
var $ae7cd955d2988a82$export$2e2bcd8739ae039 = $ae7cd955d2988a82$var$node;

});

parcelRegister("6L63Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ea40c9e1763ef8f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1ea40c9e1763ef8f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.starred",
        "defaultMessage": "Starred"
    },
    viewAllStarred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.view-all-starred",
        "defaultMessage": "View all starred"
    },
    customerService: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.customer-service",
        "defaultMessage": "Customer service"
    },
    customerServiceOverview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.customer-service-overview",
        "defaultMessage": "Customer service overview"
    }
});

});




//# sourceMappingURL=nav4-dashboards-content-entry-point-refactored.7343f0ca.js.map
